var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { dotsDefaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
var Dots = /** @class */ (function (_super) {
    __extends(Dots, _super);
    function Dots(props) {
        return _super.call(this, props) || this;
    }
    Dots.prototype.render = function () {
        var _a = this.props, children = _a.children, currIndex = _a.currIndex, className = _a.className, goTo = _a.goTo, onChange = _a.onChange, rest = __rest(_a, ["children", "currIndex", "className", "goTo", "onChange"]);
        var dotsAtomics = [
            'absolute',
            'bottom-0',
            'w-full',
            'flex',
            'justify-center',
            'items-center',
            'px-0',
            'py-px-16',
        ];
        var dotsItemAtomics = [
            'w-px-8',
            'h-px-8',
            'rounded',
            'mr-px-8',
            'bg-white',
            'opacity-20',
            'transition-all',
            'duration-100',
            'cursor-pointer',
        ];
        var dotsCurrItemAtomics = dotsItemAtomics.concat(['w-px-24', 'opacity-40']);
        return (React.createElement(DivTag, __assign({ atomics: dotsAtomics, className: "carousel-dots" }, rest), React.Children.map(children, function (child, index) {
            var dotStyle = currIndex === index ? dotsCurrItemAtomics : dotsItemAtomics;
            return (React.createElement(DivTag, { atomics: dotStyle, className: className, key: index, onClick: function () { return goTo(index); } }));
        })));
    };
    Dots.defaultProps = dotsDefaultProps;
    return Dots;
}(PureComponent));
export { Dots };
